import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDvZt2Un6DK_aD7DlDCp4tdFgMeoJeH6sM",
    authDomain: "mitra-playstore.firebaseapp.com",
    projectId: "mitra-playstore",
    storageBucket: "mitra-playstore.appspot.com",
    messagingSenderId: "120270645872",
    appId: `${process.env.REACT_APP_FIREBASE_APP_ID}`,
    measurementId: `${process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}`
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAnalytics = getAnalytics(firebaseApp);

const logFirebaseEvent = (eventName, eventParams) => {
    logEvent(firebaseAnalytics, eventName, eventParams);
}

export {logFirebaseEvent};
